export default "__VITE_ASSET__f301bb79__"